module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center"
  }, [_c('vue-core-image-upload', {
    attrs: {
      "crop": _vm.iscrop,
      "max-file-size": 5242880,
      "maxWidth": 640,
      "compress": "10",
      "text": "",
      "crop-ratio": "1:1",
      "extensions": "png,gif,jpeg,jpg",
      "cropBtn": {
        ok: '确定',
        'cancel': '取消'
      },
      "url": _vm.$host + '/mobile/upload/upimg'
    },
    on: {
      "imageuploaded": _vm.imageuploaded
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11642b2a"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/upimg.vue
// module id = 468
// module chunks = 4